/**
 * cart-shipping-progress.js
 * Fill pulse + truck-drive animation for the shipping progress bar.
 *
 * Mechanics:
 *  - Tracks previous cart percent via window.__spPrevPct (survives section re-renders)
 *  - On cartUpdate PubSub event, pulses fill AND drives truck when progress increases
 *  - Complete state animation is pure CSS on --complete
 *  - Initial page load: bar width transitions in from 0 via CSS transition
 */

(function () {
  'use strict';

  window.__spPrevPct = null;

  /** Snapshot the current progress percent before a cart action fires. */
  function capturePrev() {
    var bar = document.querySelector('.shipping-progress');
    window.__spPrevPct = bar ? parseInt(bar.dataset.progress, 10) || 0 : 0;
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('.quantity__input')) capturePrev();
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('cart-remove-button')) capturePrev();
  });

  /**
   * Find all uninitialised progress bars, animate fill + truck on progress increase.
   * Each bar is marked with data-sp-animated so repeated calls are idempotent.
   */
  function animateBars() {
    var bars = document.querySelectorAll('.shipping-progress:not([data-sp-animated])');

    bars.forEach(function (bar) {
      bar.setAttribute('data-sp-animated', '1');

      if (bar.classList.contains('shipping-progress--complete')) {
        window.__spPrevPct = 100;
        return;
      }

      var newPct  = parseInt(bar.dataset.progress, 10) || 0;
      var prevPct = window.__spPrevPct != null ? window.__spPrevPct : 0;

      if (newPct > prevPct) {
        // ── Pulse the fill ────────────────────────────────────────────────
        var fill = bar.querySelector('.sp-bar-fill');
        if (fill) {
          fill.classList.remove('sp-bar-fill--pulse');
          void fill.offsetWidth;
          fill.classList.add('sp-bar-fill--pulse');
          fill.addEventListener('animationend', function () {
            fill.classList.remove('sp-bar-fill--pulse');
          }, { once: true });
        }

        // ── Drive the truck ───────────────────────────────────────────────
        var milestone = bar.querySelector('.sp-milestone');
        if (milestone) {
          var truck = milestone.querySelector('svg');
          milestone.classList.remove('sp-milestone--drive');
          void milestone.offsetWidth;
          milestone.classList.add('sp-milestone--drive');
          // animationend doesn't bubble - listen on the SVG directly
          if (truck) {
            truck.addEventListener('animationend', function () {
              milestone.classList.remove('sp-milestone--drive');
            }, { once: true });
          } else {
            setTimeout(function () {
              milestone.classList.remove('sp-milestone--drive');
            }, 750);
          }
        }
      }

      window.__spPrevPct = newPct;
    });
  }

  // Subscribe to Dawn's PubSub - fires after each section re-render.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      requestAnimationFrame(animateBars);
    });
  }

  // Initial page-load: bar width animates in via CSS transition from 0.
  document.addEventListener('DOMContentLoaded', function () {
    window.__spPrevPct = 0;
    animateBars();
  });
})();
